<style scoped>

* {
    border: 0px black solid;
}

.project_title {
  font-size: 40px;
  font-weight: bold;
  font-family: "Open Sans", sans-serif;
  padding-bottom: 40px;
  padding-top: 100px;
}

.description_text {
  font-size: 15px;
  font-family: "Roboto Mono", monospace;
  padding-bottom: 10px;
}

.tags {
  padding-top: 10px;
  font-size: 15px;
  font-style: italic;
  font-family: "Roboto Mono", monospace;

}

a:hover {
  color: hotpink;
  text-decoration: none;

}

a {
  color: black;
}

.content {
  padding-bottom: 40px;
}
</style>

<template>
  <b-container fluid>
    <MenuBar/>
    <b-row>
      <b-col md="12">
        <p class="project_title">Repository of Feminist Search Strategies</p>
      </b-col>
    </b-row>



    <b-row class="content">
      <b-col md="4">
        <div class="description_text">
        <p class="tags">Workshop, digital libraries, tools</p>
        <p>Within this <a href="https://hackersanddesigners.nl/s/Events/p/Workshop:_Repository_of_Feminist_Search_Strategies">work session</a> we learned and exchanged about the possibilities and challenges of feminist approaches to search, and how they could be applied to a concrete contexts such as a digital library catalogs. We presented and discussed various existing projects, including XPPL and its feminist toolset.</p>
        <p>This workshop was hosted together with <a href="https://hackersanddesigners.nl/">Hackers and Designers</a>, <a href="https://read-in.info/">Read-in</a>, and <a href="http://w-i-t-m.net/">Angeliki Diakrousi</a>.</p>

      </div>
      </b-col>

      <b-col md="4">
        <b-img class="img-fluid" src="media/femtools/femtools_2.JPG"></b-img>
        <p></p>
        <b-img class="img-fluid" src="media/femtools/femtools_1.JPG"></b-img>
      </b-col>

    </b-row>

  </b-container>

</template>

<script>
import MenuBar from './MenuBar'
export default {
    name: 'FemToolsPage',
    data: function() {
        return {
        }
    },
    components: {
        MenuBar
    }
}

</script>
